import { Div } from 'alkali'
import './LoadingCircle.scss'

const LoadingCircle= Div.with('.lds-ring', [
  Div(), Div(), Div(), Div(),
])

export default LoadingCircle